import { createEvent, createStore } from 'effector';

export const openExternalUserModalEV = createEvent();

export const closeExternalUserModalEV = createEvent();

export const $externalUserModalOpen = createStore(false)
  .on(openExternalUserModalEV, () => true)
  .on(closeExternalUserModalEV, () => false);
